
<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Artificial Intelligence</h1>
		<small class="text-muted">
			AI, Deep Learning, Genetic Algorithms - technologies that can make computer think for you 
		</small>
<p class="lead">
le the creation of intelligent machines that work and react like humans is still a long way away, Artificial Intelligence application improved a lot over the past years and today it can be found almost in every area of business and everyday life.
</p>
<p>
A number of factors influenced AI technologies growth in popularity. The growing number of devices with adequate computing power and scientific progress are some of the factors, but the main improvement is that it is no longer difficult to implement AI algorithms into our projects. There are a number of ready-made libraries and modules that can be easily imported into any project, as well as there are a number of companies offering cloud-based services with specialized AI solutions 
</p>


	<div class="card mx-sm-4 my-4">
		<div class="card-body bg-secondary">
			<h5 class="card-title">AI applications</h5>
			<p>
				<ul>
					<li>Navigation</li>
					<li>Process planning and optimization</li>
					<li>Suggestion and advice engines</li>
					<li>Face and speech recognition</li>
					<li>Natural language understanding</li>
					<li>Data anomaly detection</li>
				</ul>
			</p>
		</div>
	</div>



<p>
Use of AI technologies helps businesses not just better serve their customers but also indicates the company's technological potential and long-term competitive advantage to its partners and investors.
</p>

		</div>
		<div class="col-lg-4">


			<div class="card my-5">
				<div class="card-body bg-primary text-white">
					<h5 class="card-title text-white">Cloud - accessible everywhere</h5>
					<p class="card-text">
the on-demand delivery of compute power, database, storage, applications, and other IT resources via the internet with pay-as-you-go pricing
					</p>
					<a href="#/cloud_computing" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "technology",
				title: "Artificial Intelligence"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
